import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {actions as opportunityActions, selectors as opportunitySelectors} from '../../../../Ducks/opportunity';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import {bindActionCreators} from 'redux';
import {
    Button,
    DialogActions,
    DialogContent,
    IconButton,
    List,
    ListItem,
    ListItemText,
    TextField as MaterialTextField,
    Tooltip
} from '@mui/material';
import {withStyles} from '@mui/styles';
import {styled} from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import {useParams} from "react-router-dom";
import {CLOSED_LOST, SALE_REP_NEW_REASON} from "../../../Utils/constants";
import Typography from "@mui/material/Typography";
import {DragIndicator} from "@mui/icons-material";
import Grid from "@mui/material/Grid";
import Swal from 'sweetalert2';
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import {DesktopDatePicker, LocalizationProvider} from "@mui/x-date-pickers-pro";
import {dateToString} from "../../../Utils/dateUtils";

let neverContact = null;

const useStyles = _theme => ({
    flex: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    button: {
        fontSize: '11px'
    },
    title: {
        fontWeight: '600'
    }
});

const BootstrapDialog = styled(Dialog)(({theme}) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(3),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(2),
    },
    '.MuiListItem-root': {
        paddingTop: 0,
        paddingBottom: 0
    },
    '.MuiListItem-root .MuiTypography-root': {
        fontSize: '15px'
    }
}));

const BootstrapDialogTitle = (props) => {
    const {children, onClose, handleClose, ...other} = props;

    return (
        <DialogTitle sx={{m: 0, p: 2}} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[100],
                    }}
                >
                    <CloseIcon/>
                </IconButton>
            ) : null}
        </DialogTitle>
    );
};

const NewSaleLostModal = (props) => {
    const {onClose, selectedValue, open, opportunity, classes, lostReasons, formDataValues} = props;
    const [jsonObj, setJsonObj] = React.useState({})
    const [selectedIds, setSelectedIds] = React.useState(null);
    const [showDate, setShowDate] = React.useState(false);
    const [maternityLeaveEndDate, setMaternityLeaveEndDate] = React.useState(null);

    useEffect(() => {
        props.getLostReasons({opportunity: opportunity?.main});
    }, [opportunity]);

    useEffect(() => {
        if (lostReasons !== null) {
            let reasons = lostReasons.main;

            reasons = lostReasons.main.filter((reason) => reason.group === SALE_REP_NEW_REASON)

            const obj = {
                description: "In order to close:lost this opportunity, you have to pick one reason from below",
                showQuestionNumbers: "off",
                showCompletedPage: false,
                elements: reasons
            }

            setJsonObj(obj);
        }
    }, [lostReasons]);

    React.useEffect(() => {
        const isMaternity = selectedIds?.title === "Maternity leave";

        if (!isMaternity) {
            setShowDate(isMaternity);
            setMaternityLeaveEndDate(null);
        } else {
            setShowDate(isMaternity);
            setMaternityLeaveEndDate(null);
        }
    }, [selectedIds]);

    const handleClose = () => {
        setSelectedIds(null);
        onClose(selectedValue);
    };

    const onComplete = (_e, never_contact = false) => {
        if (selectedIds == null || selectedIds.length === 0) {
            Swal.fire({
                icon: 'warning',
                title: 'Please select a reason!',
                showConfirmButton: false,
                timer: 1500
            });

            return false;
        }

        neverContact = never_contact;
        let closed_lost_reasons_ids = {[selectedIds.name]: String(selectedIds.id)};
        neverContact = neverContact !== true && maternityLeaveEndDate !== null ? true : neverContact;

        let closedLostReasonsData = {
            closed_lost_reasons_ids,
            id: props.params.id,
            never_contact: neverContact,
            never_contact_till: maternityLeaveEndDate,
            userStageId: opportunity.main.pipeline_stage_id,
            person_food_considerations_1: formDataValues?.person_food_considerations_1,
            person_food_considerations_2: formDataValues?.person_food_considerations_2,
            person_food_considerations_other: formDataValues?.person_food_considerations_other
        };

        props.updateOpportunityStatus({
            opportunity_status: CLOSED_LOST,
            person_food_considerations_1: formDataValues?.person_food_considerations_1,
            person_food_considerations_2: formDataValues?.person_food_considerations_2,
            person_food_considerations_other: formDataValues?.person_food_considerations_other
        });

        props.postClosedLostReasons(closedLostReasonsData);

        handleClose();
    }

    const toggleSingleSelect = (element) => {
        setSelectedIds((prev) => (prev === element ? null : element));
    };

    return (
        <BootstrapDialog onClose={handleClose} open={open} fullWidth maxWidth="md">
            <BootstrapDialogTitle sx={{backgroundColor: '#1565c0', color: 'white'}} onClose="true"
                                  handleClose={handleClose}>
                Opportunity lost reasons
            </BootstrapDialogTitle>
            <DialogContent>
                <Typography component="h6" sx={{padding: "10px"}}>
                    {jsonObj?.description}
                </Typography>
                <Grid>
                    <List component="div" disablePadding>
                        {jsonObj.elements?.map((element, index) => {
                            const key = element.id ?? element.name ?? index;
                            const isSelected = selectedIds == element; // if id exists

                            return (
                                <ListItem
                                    key={key}
                                    button
                                    onClick={() => toggleSingleSelect(element)}
                                    sx={{
                                        padding: "5px",
                                        mb: "5px",
                                        border: "1px solid #F0F0F0",
                                        borderRadius: "7px",
                                        backgroundColor: isSelected ? "#1565c0" : "white",
                                        color: isSelected ? "white" : "black",
                                        transition: "background-color 0.2s ease",
                                    }}
                                >
                                    <Tooltip title="Click to select" placement="top">
                                        <DragIndicator/>
                                    </Tooltip>

                                    <ListItemText primary={element.title} sx={{pl: "5px"}}/>
                                </ListItem>
                            );
                        })}
                    </List>

                    {showDate === true && (

                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DesktopDatePicker
                                label="Maternity Leave End Date"
                                inputFormat="yyyy/MM/dd"
                                value={maternityLeaveEndDate}
                                onChange={(newValue) => {
                                    if (newValue) {
                                        const formatDate = dateToString(newValue, 'yyyy/MM/dd');
                                        setMaternityLeaveEndDate(formatDate);

                                    }
                                }}
                                renderInput={(params) => <MaterialTextField
                                    sx={{margin: '10px 0'}} fullWidth
                                    size='small' {...params} />}
                            />
                        </LocalizationProvider>
                    )}
                </Grid>
            </DialogContent>
            <DialogActions className={classes.flex}>
                <Button className={classes.button} variant="contained" color="error"
                        onClick={(e) => onComplete(e, true)}>Closed:lost never contact</Button>
                <Button className={classes.button} variant="contained" color='warning'
                        onClick={onComplete}>Closed:lost</Button>
                <Button className={classes.button} variant="contained" color="primary" onClick={handleClose}>Cancel
                                                                                                             closed:lost
                                                                                                             action</Button>
            </DialogActions>
        </BootstrapDialog>
    );
}

const mapStateToProps = (state) => ({
    isLoading: opportunitySelectors.getLostReasons_loading(state),
    errorMessage: opportunitySelectors.errorMessage(state),
    lostReasons: opportunitySelectors.lostReasons(state),
    opportunity: opportunitySelectors.opportunity(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators(
    {
        getLostReasons: opportunityActions.getLostReasons,
        postClosedLostReasons: opportunityActions.postClosedLostReasons,
        updateOpportunityStatus: opportunityActions.updateOpportunityStatus
    },
    dispatch);

function WithNavigate(props) {
    let params = useParams();
    return <NewSaleLostModal {...props} params={params}/>
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(useStyles)(WithNavigate));